import React, { useState, useEffect } from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Animation state pour chaque élément
  const [showCircle, setShowCircle] = useState(false);
  const [showPhoto, setShowPhoto] = useState(false);
  const [showWassim, setShowWassim] = useState(false);
  const [showMhadhbi, setShowMhadhbi] = useState(false);
  const [showUiux, setShowUiux] = useState(false);

  useEffect(() => {
    // Apparition dynamique et percutante
    const t0 = setTimeout(() => setShowCircle(true), 100);
    const t0b = setTimeout(() => setShowPhoto(true), 200);
    const t1 = setTimeout(() => setShowWassim(true), 500);
    const t2 = setTimeout(() => setShowMhadhbi(true), 800);
    const t3 = setTimeout(() => setShowUiux(true), 1100);
    return () => {
      clearTimeout(t0);
      clearTimeout(t0b);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <section id="accueil" className="relative min-h-[48vh] md:min-h-screen flex items-center justify-center overflow-hidden bg-black pb-0 md:pb-0">

      {/* Cercle contour derrière tous les éléments */}
      <div 
        className="absolute left-1/2 pointer-events-none z-0 top-[calc(30%+70px)] md:top-[calc(50%-20px)]" 
        style={{
          transform: 'translate(-50%, -50%)',
          opacity: showCircle ? 1 : 0,
          scale: showCircle ? 1 : 0.3,
          filter: showCircle ? 'blur(0px)' : 'blur(20px)',
          transition: 'all 1s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}
      >
        <div className="w-[207px] h-[207px] md:w-[395px] md:h-[395px] rounded-full p-[4.32px] md:p-[7.2px] animate-spin" 
             style={{
               background: 'conic-gradient(from 0deg, #DC1A5F, #32D6E0, #DC1A5F, #32D6E0, #DC1A5F)',
               animation: 'spin 8s linear infinite'
             }}>
          <div className="w-full h-full rounded-full bg-black"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Image centrée de Wassim avec texte en overlay */}
        <div className="flex justify-center items-center min-h-[80vh] mt-[20px] md:mt-[100px]">
          <div className="text-center relative">
            
            {/* Container pour l'image et les textes overlay */}
            <div className="relative inline-block scale-[0.6] md:scale-100" style={{transformOrigin: 'center'}}>
              <img 
                src="/re.png" 
                alt="Wassim Mhadhbi - UI/UX Designer"
                className="mx-auto max-w-md h-auto rounded-2xl shadow-2xl transition-all duration-500 hover:scale-105 hover:grayscale-0"
                style={{
                  opacity: showPhoto ? 1 : 0,
                  transform: showPhoto ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.85)',
                  filter: showPhoto ? 'grayscale(1) blur(0px)' : 'blur(15px)',
                  transition: 'all 1s cubic-bezier(0.34, 1.56, 0.64, 1)',
                  animation: showPhoto ? 'photoAppear 2s ease-out forwards' : 'none'
                }}
              />
              
              {/* WASSIM en overlay sur les bras - taille fixe pour tous les devices */}
              <h1 className="absolute inset-0 flex items-center justify-center font-bold text-white tracking-tight pointer-events-none" style={{paddingTop: '40%', fontSize: '8rem'}}>
                <span
                  style={{
                    opacity: showWassim ? 1 : 0,
                    transform: showWassim ? 'translateY(0) rotate(0deg)' : 'translateY(-50px) rotate(-5deg)',
                    filter: showWassim ? 'blur(0px)' : 'blur(10px)',
                    transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)'
                  }}
                >
                  WASSIM
                </span>
              </h1>
              
              {/* MHADHBI plus en bas pour éviter qu'il colle à WASSIM - taille fixe */}
              <h2 className="absolute inset-0 flex items-center justify-center font-light text-white uppercase pointer-events-none whitespace-nowrap" style={{paddingTop: '90%', fontSize: '3.03rem', transform: 'translateY(-32px) translateX(20px)', letterSpacing: '0.31em'}}>
                <span
                  style={{
                    opacity: showMhadhbi ? 1 : 0,
                    transform: showMhadhbi ? 'translateX(0) scale(1)' : 'translateX(-80px) scale(0.7)',
                    filter: showMhadhbi ? 'blur(0px)' : 'blur(8px)',
                    transition: 'all 0.9s cubic-bezier(0.34, 1.56, 0.64, 1)'
                  }}
                >
                  M H A D H B I
                </span>
              </h2>
            </div>
            
            {/* UI UX DESIGNER en dessous de l'image */}
            <div className="mt-6 md:mt-6 -translate-y-[212px] md:-translate-y-[138px] translate-x-[8px] md:translate-x-[15px]">
              <h3 className="font-bold" style={{
                fontSize: 'clamp(1.8rem, 5vw, 2.7rem)', 
                letterSpacing: '0.004em', 
                opacity: showUiux ? 1 : 0, 
                transform: showUiux ? 'translateY(0) scale(1)' : 'translateY(30px) scale(1.3)', 
                filter: showUiux ? 'blur(0px)' : 'blur(6px)', 
                transition: 'all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)',
                background: 'linear-gradient(90deg, #DC1A5F, #B91651, #32D6E0, #DC1A5F)',
                backgroundSize: '200% 200%',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                animation: 'subtleGradient 6s ease-in-out infinite'
              }}>
                U I<span style={{marginLeft: '24px', marginRight: '12px'}}>U X</span><span className="ml-[12px] md:ml-[24px]">D E S I G N E R</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;